
export enum TouristSign {
  Undefined = 'Undefined',
  BlueLine = 'BlueLine',
  BlueCross = 'BlueCross',
  BlueCircle = 'BlueCircle',
  BlueTriangle = 'BlueTriangle',
  YellowLine = 'YellowLine',
  YellowCross = 'YellowCross',
  YellowCircle = 'YellowCircle',
  YellowTriangle = 'YellowTriangle',
  RedLine = 'RedLine',
  RedCross = 'RedCross',
  RedCircle = 'RedCircle',
  RedTriangle = 'RedTriangle',
}
